import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { httpGet } from 'giro-react-toolkit/source/UtilityFunctions/Ajax';
import Loading from 'giro-react-toolkit/source/Loading';
import { Translation } from 'giro-react-toolkit/source/Translation';

import { MapImageLayer } from 'Map'
import { ErrorBannerContext } from 'ErrorBanner'

import './IsochroneMapLayer.scss';

/**
 * Isochrone map layer component
 */
class IsochroneMapLayer extends Component {
   constructor(props) {
      super(props);
      this.state = { bounds: undefined, image: undefined, loading: false };

      this.handleRefreshButtonClick = this.handleRefreshButtonClick.bind(this);

      // utilisé pour le fetch d'isochrone, permet d'annuler un appel pour éviter d'avoir les
      // retours multiple dans le désordre et de ne pas afficher la bonne information
      this.abortController = null;
   }

   /**
    * Fetches the isochrone from the web services
    */
   getIsochrone(firstLoad) {
      // Cancel the in progress isochrone request and make a new one.
      if (this.abortController)
         this.abortController.abort();

                             // props must be initialized to fetch image
      if (!this.arePropsInitialized()) {
                             // remove the existing isochrone map layer
         this.setState({ bounds: undefined, image: undefined, loading: false });
         return;
      }

      var params = {
         latitude: this.props.latitude,
         longitude: this.props.longitude,
         day: this.props.day,
         time: this.props.time,
         duration: this.props.duration,
         scenario: this.props.concept
      }

      this.setState({ loading: true });

      var showError = (response) => {
         this.context.displayErrorMessage(
            "ReachMapRes.IsochroneFetchErrorText",
            [ response.status ],
            () => {
               this.getIsochrone()
            } /*retryFct*/);
      };

      if (window.AbortController)
         this.abortController = new AbortController();

      var signal = this.abortController ? this.abortController.signal : null;

      httpGet('home/ReachMap', { params, fetchOptions: { signal }, errorHandler: showError }).then(result => {
         // on successful response, update object
         this.setState({
            bounds: result ? result.Bounds : undefined,
            image: result ? ("data:image/jpeg;base64," + result.Image) : undefined,
            loading: false
         });
         if (this.props.onFetchCompleted) {
            this.props.onFetchCompleted(result && result.Image /*hasImage*/, firstLoad);
         }

      });
   }

   arePropsInitialized() {
      return (this.props.latitude &&
         this.props.longitude &&
         this.props.day &&
         this.props.time &&
         this.props.duration &&
         this.props.concept);
   }

   componentDidMount() {
      this.getIsochrone(true /*firstLoad*/);
   }

   componentDidUpdate(prevProps) {
                             // If props have changed, fetch new isochrone
      if (this.props.latitude !== prevProps.latitude ||
          this.props.longitude !== prevProps.longitude ||
          this.props.day !== prevProps.day ||
          this.props.duration !== prevProps.duration ||
          this.props.time !== prevProps.time ||
          this.props.concept !== prevProps.concept) {
         this.getIsochrone(false /*firstLoad*/);
      }
   }

   handleRefreshButtonClick() {
      if (this.props.onRefreshButtonClick)
         this.props.onRefreshButtonClick();
   }

   generateRefreshButton() {
      /* TODO le bouton devrait être mis dans app */
      return (
         <button id="refreshIsochrone"
            className="map-button refresh-isochrone-button"
            onClick={() => {
               this.handleRefreshButtonClick()
            }}>
            <Translation resourceKey={ 'ReachMapRes.RefreshIsochroneButtonText' }/>
         </button>
      );
   }

   /**
    * Render Isochrone layer on map
    */
   render() {
      return (
         <React.Fragment>
            {this.props.showRefreshButton && this.generateRefreshButton()}
            {this.state.loading && <Loading isFullScreen isDisplayed centered delayed={false} />}
            {this.arePropsInitialized() && this.state.image && this.state.bounds &&
            <MapImageLayer
               imageUrl= {this.state.image}
               imageBounds= {this.state.bounds}
               {...this.props} />}
         </React.Fragment>);
   }
}

IsochroneMapLayer.contextType = ErrorBannerContext;

IsochroneMapLayer.propTypes = {
   /**
    * defines the latitude of the start point for the isochrone
    */
   latitude: PropTypes.number,
   /**
    * defines the longitude of the start point for the isochrone
    */
   longitude: PropTypes.number,
   /**
    * defines the day of the week (monday, tuesday, etc) for the isochrone
    */
   day: PropTypes.string,
   /**
    * defines the total max duration for the isochrone
    */
   duration: PropTypes.number,
   /**
    * defines the time for the start point of the isochrone in format hh:mm
    */
   time: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date)
   ]),
   /**
    * defines the selected concept
    */
   concept: PropTypes.string,
   /**
    * Called when the fetch is completed
    */
   onFetchCompleted: PropTypes.func,
   /**
    * The isochrone map layer shows the refresh button
    */
   showRefreshButton: PropTypes.bool,
   /**
    * Called when the refresh button is clicked
    */
   onRefreshButtonClick: PropTypes.func
}

export default IsochroneMapLayer;
